import { render, staticRenderFns } from "./studioDashboardSlimMe.vue?vue&type=template&id=19ecd46b&scoped=true"
import script from "./studioDashboardSlimMe.vue?vue&type=script&lang=js"
export * from "./studioDashboardSlimMe.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardSlimMe.vue?vue&type=style&index=0&id=19ecd46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ecd46b",
  null
  
)

export default component.exports